import { t } from '../../i18n'
import { Title } from '../AnimalInsuranceTable/styles'
import { Status, TypeProps } from './Status'
import { Container, TabContainer } from './styles'

type QuoteRequestStatusProps = {
  type: TypeProps
  typeMessage: string
  children: React.ReactNode
}

export const QuoteRequestStatus = ({
  type,
  children,
  typeMessage,
}: QuoteRequestStatusProps) => {
  return (
    <Container>
      <Title>{t('pages.step5.requestAuthorization.title')}</Title>
      <Status type={type} typeMessage={typeMessage} />
      <TabContainer>{children}</TabContainer>
    </Container>
  )
}
